import script from "./vmsOppWorkflowManager.vue?vue&type=script&lang=js"
export * from "./vmsOppWorkflowManager.vue?vue&type=script&lang=js"

import "./vmsOppWorkflowManager.vue?vue&type=style&index=0&id=19459ff3&scoped=true&lang=css"
import "./vmsOppWorkflowManager.vue?vue&type=style&index=1&id=19459ff3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19459ff3"]])

export default __exports__